(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/ticker.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/ticker.js');


'use strict';

const {
  useEffect,
  useState,
  useRef
} = React;
const {
  isUserIdleAtom,
  mapZoomLevelAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  charityAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  useAtomValue
} = jotai;
const {
  CharityLogo
} = svs.lyckoplatsen.components.page_play.react.components;
const {
  shouldShowPinAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const baseContent = ['Var vill du spela?', 'Klicka för att välja plats.', 'Var lärde du dig cykla?', 'Du kan spela på din hemadress.', 'Var mår du bäst?', 'Du kan spela där du är.'];
const Ticker = () => {
  var _contentRef$current;
  const charity = useAtomValue(charityAtom);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideRef = useRef(null);
  const isUserIdle = useAtomValue(isUserIdleAtom);
  const mapZoomLevel = useAtomValue(mapZoomLevelAtom);
  const shouldShowPin = useAtomValue(shouldShowPinAtom);
  const slideTime = 3200;
  const contentRef = useRef(charity ? baseContent.flatMap((item, index) => index % 2 === 0 ? [item, React.createElement("div", {
    key: "logo-".concat(index)
  }, React.createElement(CharityLogo, null))] : [item]) : baseContent);
  useEffect(() => {
    contentRef.current = charity ? baseContent.flatMap((item, index) => index % 1 === 0 ? [item, React.createElement("div", {
      key: "logo-".concat(index)
    }, React.createElement(CharityLogo, null))] : [item]) : baseContent;
  }, [charity]);
  useEffect(() => {
    if (shouldShowPin) {
      setCurrentSlide(0);
    }
  }, [shouldShowPin]);
  useEffect(() => {
    if (isUserIdle) {
      const slideInterval = setInterval(() => {
        gsap.to(slideRef.current, {
          x: '-100%',
          opacity: 0,
          duration: 0.5,
          ease: 'power4.out',
          onComplete: () => {
            setCurrentSlide(prevSlide => (prevSlide + 1) % contentRef.current.length);
            gsap.set(slideRef.current, {
              x: '100%'
            });
            gsap.to(slideRef.current, {
              x: '0%',
              opacity: 1,
              duration: 0.5,
              ease: 'power4.out'
            });
          }
        });
      }, slideTime);
      return () => clearInterval(slideInterval);
    }
  }, [isUserIdle, mapZoomLevel]);
  return React.createElement("div", {
    className: "lp-play-ticker-wrapper ".concat(isUserIdle ? 'ticker-show' : 'ticker-hide')
  }, React.createElement("div", {
    className: "ticker-overflow-hide"
  }, React.createElement("div", {
    className: "ticker-slide",
    ref: slideRef
  }, ((_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current[currentSlide]) || '')));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Ticker
});

 })(window);